import { useAtom, useSetAtom } from "jotai";
import { useCallback } from "react";
import { toast } from "react-toastify";
import {
  taskErrorAtom,
  userErrorAtom,
  globalErrorAtom,
} from "../../store/atoms/asyncAtoms.js";

export const useErrorHandler = () => {
  const [taskError, setTaskError] = useAtom(taskErrorAtom);
  const [userError, setUserError] = useAtom(userErrorAtom);
  const [globalError, setGlobalError] = useAtom(globalErrorAtom);

  const handleTaskError = useCallback(
    (error, showToast = true) => {
      console.error("Task error:", error);
      setTaskError(error.message || "An error occurred");

      if (showToast) {
        toast.error(error.message || "Failed to process task operation");
      }

      // Auto-clear error after 5 seconds
      setTimeout(() => setTaskError(null), 5000);
    },
    [setTaskError]
  );

  const handleUserError = useCallback(
    (error, showToast = true) => {
      console.error("User error:", error);
      setUserError(error.message || "An error occurred");

      if (showToast) {
        toast.error(error.message || "Failed to process user operation");
      }

      // Auto-clear error after 5 seconds
      setTimeout(() => setUserError(null), 5000);
    },
    [setUserError]
  );

  const handleGlobalError = useCallback(
    (error, showToast = true) => {
      console.error("Global error:", error);
      setGlobalError(error.message || "An error occurred");

      if (showToast) {
        toast.error(error.message || "An unexpected error occurred");
      }

      // Auto-clear error after 5 seconds
      setTimeout(() => setGlobalError(null), 5000);
    },
    [setGlobalError]
  );

  const clearErrors = useCallback(() => {
    setTaskError(null);
    setUserError(null);
    setGlobalError(null);
  }, [setTaskError, setUserError, setGlobalError]);

  return {
    taskError,
    userError,
    globalError,
    handleTaskError,
    handleUserError,
    handleGlobalError,
    clearErrors,
  };
};
